import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function EngineeringTheExplorer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="engineering-the-explorer" ref={ref} className={cn("dark bg-background text-foreground", "bg-[hsl(35_30%_88%)] text-[hsl(220_15%_10%)]", "relative py-20 md:py-32 overflow-hidden transition-opacity duration-1000")}>
      <div className={cn("container mx-auto px-6 md:px-12 max-w-5xl", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8", "transition-all duration-1000 ease-out")}>
        <div className="flex flex-col gap-12 md:gap-16">
          {}
          <div className="space-y-6">
            <h2 className="text-sm font-mono uppercase tracking-widest text-[hsl(220_15%_30%)] mb-4 border-b border-[hsl(220_15%_10%)]/20 pb-2 inline-block">
              Engineering the Explorer
            </h2>
            <p className="text-xl md:text-2xl leading-relaxed font-sans font-light text-[hsl(220_15%_20%)]">
              Building a rig for the American West isn't just about bolting on
              accessories; it's about engineering a system that can sustain a
              family in remote environments. Every modification on our trucks is
              deliberate, tested, and purpose-built for the terrain we traverse.
              From the scorching heat of the Mojave to the high-altitude passes
              of the Rockies, we prioritize reliability over aesthetics.
            </p>
          </div>

          {}
          <div className="relative py-8 md:py-12">
            <span className="absolute top-0 left-0 text-6xl md:text-8xl text-primary/20 font-serif leading-none -translate-x-4 -translate-y-4 select-none">
              &ldquo;
            </span>
            <blockquote className="relative z-10">
              <p className="text-4xl md:text-6xl font-serif text-primary leading-[0.9] tracking-wide uppercase text-center md:text-left">
                Capability is the foundation of family safety in the
                backcountry.
              </p>
            </blockquote>
          </div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 hidden md:block border-t border-[hsl(220_15%_10%)]/20 pt-4">
              <span className="text-sm font-mono text-[hsl(220_15%_40%)] block mb-1">
                Location
              </span>
              <span className="text-base font-medium block">
                American West, USA
              </span>
            </div>
            <div className="md:col-span-8">
              <p className="text-lg md:text-xl leading-relaxed text-[hsl(220_15%_20%)]">
                This approach—prioritizing function over form—ensures that our
                adventures aren't cut short by mechanical failure. We document
                our build process not just to show off gear, but to explain the
                "why" behind every modification. Whether it's a suspension
                upgrade for load handling or a dual-battery system for extended
                off-grid stays, our goal is to demystify the technical side of
                overlanding and help you build a rig that gets you there and
                back again.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}